import type { AppRouter } from '@alison/api/router';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import type { TRPCClientErrorLike } from '@trpc/client';
import type { inferInput, inferOutput } from '@trpc/tanstack-react-query';
import { useTRPC } from '../../../../lib/trpc';

type TRPC = ReturnType<typeof useTRPC>;

type QueryResult<TData> = UseQueryResult<TData, TRPCClientErrorLike<AppRouter>>;

export type CompetitionCreativesScope = Omit<inferInput<TRPC['competition']['creatives']>, 'limit'>;
export type CompetitionCreativesData = inferOutput<TRPC['competition']['creatives']>;
export type CompetitionCreativeRow = CompetitionCreativesData['creatives'][number];

export type CompetitionTopMetricsScope = inferInput<TRPC['competition']['topMetrics']>;
export type CompetitionTopMetricsData = inferOutput<TRPC['competition']['topMetrics']>;

export type CompetitionCreativeScope = Omit<
  inferInput<TRPC['competition']['creative']>,
  'creativeId'
>;
export type CompetitionCreativeData = inferOutput<TRPC['competition']['creative']>;

export function useCompetitionCreativesList(
  scope: CompetitionCreativesScope,
  enabled: boolean,
): QueryResult<CompetitionCreativesData> {
  const trpc = useTRPC();
  return useQuery({ ...trpc.competition.creatives.queryOptions(scope), enabled });
}

export function useCompetitionTopMetrics(
  scope: CompetitionTopMetricsScope,
  enabled: boolean,
): QueryResult<CompetitionTopMetricsData> {
  const trpc = useTRPC();
  return useQuery({ ...trpc.competition.topMetrics.queryOptions(scope), enabled });
}

export function useCompetitionCreative(
  scope: CompetitionCreativeScope & { creativeId: string },
  enabled: boolean,
): QueryResult<CompetitionCreativeData> {
  const trpc = useTRPC();
  return useQuery({ ...trpc.competition.creative.queryOptions(scope), enabled });
}
